import SubcategoryPage from '@/components/template/SubcategoryPage';

const IndexSupportLights = () => {
  const products = [
    {
      title: "Index Support Model 1",
      imageSrc: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&q=80",
      url: "/svetila/index-support/model-1"
    },
    {
      title: "Index Support Model 2",
      imageSrc: "https://images.unsplash.com/photo-1540932239986-30128078f3c5?auto=format&fit=crop&q=80",
      url: "/svetila/index-support/model-2"
    },
    {
      title: "Index Support Model 3",
      imageSrc: "https://images.unsplash.com/photo-1551255868-31059b23ab32?auto=format&fit=crop&q=80",
      url: "/svetila/index-support/model-3"
    },
    {
      title: "Index Support Model 4",
      imageSrc: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&q=80",
      url: "/svetila/index-support/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Index Support Lights"
      description="Moderne podporne svetilke za vašo kopalnico, ki zagotavljajo optimalno osvetlitev in dodajajo sodobni pridih vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default IndexSupportLights;